// extracted by mini-css-extract-plugin
export var loadingSpinner = "_15-0";
export var spinnerContainer = "_15-1";